<template>
  <!-- 福来礼 订单详情 -->
  <div class='order-detail'>
    <div class='status-wrap'>
      <div style='display: flex; align-items: center'>
        <img class='status-icon' :src='statusIcon' alt='' />
        <div class='status-text'>{{ statusText }}</div>
      </div>
      <div class='status-amount'><span style='font-size: 0.14rem'>¥ </span>{{ payInfo.payAmount }}</div>
    </div>

    <div class='info-card'>
      <div class='info-row'>
        <span class='label'>订单号</span>
        <span class='value'>{{ orderInfo.orderId }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>商品名称</span>
        <span class='value'>{{ orderInfo.productName }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>用户手机号</span>
        <span class='value'>{{ orderInfo.telnum }}</span>
      </div>
    </div>

    <div class='info-card'>
      <div class='info-row'>
        <span class='label'>购买数量</span>
        <span class='value'>{{ payInfo.orderQuantity }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>订单金额</span>
        <span class='value'>¥ {{ payInfo.orderAmount }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>实付金额</span>
        <span class='value'>¥ {{ payInfo.payAmount }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>下单时间</span>
        <span class='value'>{{ payInfo.orderTime }}</span>
      </div>
    </div>

    <div class='info-card' v-if='status == "30" || status == "20"'>
      <div class='info-row'>
        <span class='label'>退款金额</span>
        <span class='value'>¥{{ refundInfo.refundAmount }}</span>
      </div>
      <div class='info-row'>
        <span class='label'>退款完成时间</span>
        <span class='value'>{{ refundInfo.refundFinishTime }}</span>
      </div>
    </div>

    <div style='display: flex;justify-content: flex-end'>
      <van-button plain type='info' color='#CECECE' @click='checkDetail'>查看详情</van-button>
    </div>
  </div>
</template>

<script>
import { getFllOrderDetail } from '@/api/fulaili'

export default {
  name: 'FllOrderDetail',
  data() {
    return {
      orderId: '', // 订单号
      status: '', // 订单状态：1-待支付；2-进行中；3-已完成；4-已取消；30-退款完成
      statusText: '', // 状态文案
      statusIcon: '', // 状态图标
      orderInfo: {}, // 订单信息
      payInfo: {}, // 支付信息
      refundInfo: {}, // 退款信息
      detailUrl: '' // 详情链接
    }
  },
  created() {
    this.orderId = this.$route.query.orderId || ''
    this.getDetail()
  },
  methods: {
    // 获取订单详情
    getDetail() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      getFllOrderDetail({
        orderId: this.orderId
      })
        .then((res) => {
          this.$toast.clear()
          if (res.code === 200 && res.data) {
            this.initData(res.data)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // 初始化数据
    initData(data) {
      this.orderInfo = data.orderInfo || {}
      this.payInfo = data.payInfo || {}
      this.refundInfo = data.refundInfo || {}
      this.status = data.orderInfo.orderStatus || ''
      this.detailUrl = data.url || ''
      this.setStatusIcon()
    },
    // 设置状态图标
    setStatusIcon() {
      const iconMap = {
        '1': require('@/assets/img/status/ic-unpaid.png'), // 待支付
        '2': require('@/assets/img/status/ic-going.png'), // 进行中
        '3': require('@/assets/img/status/ic-finished.png'), // 已完成
        '4': require('@/assets/img/status/ic-canceled.png'), // 已取消
        '30': require('@/assets/img/status/ic-refunded.png'), // 已退款
        '20': require('@/assets/img/status/ic-refunded.png'), // 已退款
        '5': require('@/assets/img/status/ic-failed.png') // 已退款
      }
      const textMap = {
        '1': '待支付',
        '2': '进行中',
        '3': '已完成',
        '4': '已取消',
        '30': '已退款',
        '20': '已退款',
        '5': '购买失败'
      }
      this.statusIcon = iconMap[this.status]
      this.statusText = textMap[this.status]
    },
    // 查看详情
    checkDetail() {
      if (this.detailUrl) {
        window.location.href = this.detailUrl
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.order-detail {
  min-height: 100vh;
  padding: 0.1rem;
  background-color: #f6f6f6;
  box-sizing: border-box;

  .status-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.4rem 0 0.25rem;

    .status-icon {
      width: 0.36rem;
      height: 0.36rem;
    }

    .status-text {
      font-size: 0.16rem;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #0D0D0D;
      margin-left: 0.12rem;
    }

    .status-amount {
      margin-top: 0.12rem;
      font-size: 0.27rem;
      font-family: DIN, DIN;
      font-weight: bold;
      color: #FF1B0F;
      line-height: 0.33rem;
    }
  }

  .info-card {
    width: 100%;
    background: #ffffff;
    border-radius: 0.06rem;
    padding: 0.12rem;
    margin-bottom: 0.1rem;
    box-sizing: border-box;

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 0.44rem;
      font-size: 0.14rem;
      font-family: PingFangSC, PingFangSC-Regular;

      .label {
        color: #666666;
        font-weight: 400;
        white-space: nowrap;
      }

      .value {
        color: #0D0D0D;
        line-height: 0.2rem;
        font-weight: 500;
        text-align: right;
      }
    }
  }

  .van-button {
    height: 0.3rem;
    align-self: end;
    border: 0.01rem solid #cecece;
    border-radius: 0.04rem;
    margin-top: 0.1rem;

    .van-button__text {
      font-size: 0.13rem;
      font-family: PingFang SC/PingFang SC-Regular;
      font-weight: 500;
      color: #0d0d0d;
    }
  }
}
</style>
